// @ts-check

import USER from '../ts/profileEditorEnum';

/**
 * @function assignAddressLabel
 * @description Gets the address label based on the given index.
 * @param {number} index The index of the address label.
 * @returns {TitleType} The corresponding address label.
 * @throws {Error} Throws an error if the index is out of range.
 */
function assignAddressLabel(index) {
	const ADDRESS_LABELS = [USER.WORK, USER.HOME, USER.OTHER];

	if (index < 0 || index >= ADDRESS_LABELS.length) {
		throw new Error(`Invalid index: ${index}`);
	}

	return ADDRESS_LABELS[index];
}

export default assignAddressLabel;
